import { gql } from '@apollo/client'

import { CustomerFragment } from '../fragments'

export const CUSTOMER = gql`
  query customer {
    customer {
      ...CustomerFragment
    }
  }
  ${CustomerFragment}
`

export const REQUEST_PAYMENT_METHOD_REGISTER_LINK = gql`
  query requestPaymentMethodRegisterLink($input: RequestPaymentMethodRegisterLinkInput!) {
    requestPaymentMethodRegisterLink(input: $input)
  }
`

export const REQUEST_CUSTOMER_DASHBOARD_LINK = gql`
  query requestCustomerDashboardLink {
    requestCustomerDashboardLink
  }
`
